<template>
  <div class="dialog_box">
    <el-dialog title="审核工单" :visible="show" width="437px" @close="dialogClose" top="20vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <el-form ref="form" class="form_box" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="审核人员" prop="username">
            <el-input v-model="form.username" placeholder="请输入备注" disabled></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="isPass">
            <el-radio v-model="form.isPass" :label="true">通过审核</el-radio>
            <el-radio v-model="form.isPass" :label="false">驳回审核</el-radio>
          </el-form-item>
          <el-form-item label="备注" :prop="!form.isPass ? 'reason' : ''">
            <el-input v-model="form.reason" type="textarea" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      form: {
        isPass: null,
        orderId: 0,
        reason: "",
      },
      imgUrl: "",
      stateList: [],
      rules: {
        username: [
          {
            required: true,
            message: "请输入审核人员",
            trigger: ["blur", "change"],
          },
        ],
        isPass: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        reason: [
          {
            required: true,
            message: "请输入备注",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  created () {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.form.username = userInfo.username;
  },
  methods: {
    dialogClose () {
      this.$emit("update:show", false);
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.form.orderId = this.data.id
        this.$http.auditWorkOrder(this.form).then((res) => {
          if (res.code === 0) {
            this.$parent.getDaiShengheList();
            this.$parent.getOrderNum();
            this.$emit("update:show", false);
          } else {
            this.$message.error(res.msg)
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.el-dialog__body {
  overflow-y: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/views/workOrder_Audit/component/audit.vue